module.exports = __webpack_public_path__ + "img/Logo.db1f0bd2.png";